<div class="order-info">
  <div class="order-info_order-id" [ngClass]="{'order-info_order-id--no-click': !url}" >
   <a (click)="openLink(params.data)"> {{ params.data.Orderid }} </a>
    <i
      class="fal"
      [ngClass]="{ 'fa-copy': !copied, 'fa-check': copied }"
      [cdkCopyToClipboard]="params.data.Orderid"
      (cdkCopyToClipboardCopied)="copy($event)"
    ></i>
  </div>
  <div class="order-info_order-date">
    {{ params.data.Purchased | date: "short" }}
  </div>
</div>
